import "./style.scss";
import { useEffect, useState } from "react";
import { admissionsOfficeHeaderTabsConst } from "@/src/constants/AdmissionOffice/admissionsOfficeConsts";
import { useDispatch } from "react-redux";
import { setTabsAdmissionsOffice } from "@/src/store/slices/AdmissionOffice/admissionOfficeDocSlice";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SelectDefault from "../../SelectDefault/SelectDefault";
import BtnDefault from "../../BtnDefault/BtnDefault";
import Refresh from "@/src/svg/header/Refresh";
import DatabaseSvg from "@/src/svg/admissionOfficePage/DatabaseSvg";
import VerticalLine from "../../VerticalLine/VerticalLine";

type AdmissionsLang = "en" | "fr" | "de";

const HeaderAdmissionsOffice = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState<string>("");
  const [currentSelect, setCurrentSelect] = useState<string>("");

  const parseAdmissionsOfficeUrl = (pathname: string) => {
    const parts = pathname.split("/").filter(Boolean);

    if (parts[0] !== "admissions-office") return null;

    let lang: AdmissionsLang = "en";
    let country: string | undefined;
    let slug: string | undefined;

    if (parts[1] === "fr" || parts[1] === "de") {
      lang = parts[1];
      country = parts[2];
      slug = parts[3];
    } else {
      country = parts[1];
      slug = parts[2];
    }

    if (!country || !slug) return null;

    const tabObj = admissionsOfficeHeaderTabsConst.find((t) => t.id === country);
    if (!tabObj) return null;

    const option = tabObj.mass.find((m) => m.slug === slug && (m.lang ?? "en") === lang);
    if (!option) return null;

    return {
      tabId: tabObj.id,
      selectName: option.name,
      lang,
    };
  };

  useEffect(() => {
    const parsed = parseAdmissionsOfficeUrl(location.pathname);
    if (!parsed) return;

    setCurrentTab(parsed.tabId);
    setCurrentSelect(parsed.selectName);
    dispatch(setTabsAdmissionsOffice(parsed.tabId));
  }, [location.pathname, dispatch]);

  const handleEventTab = (id: string) => {
    setCurrentTab(id);
    const tabObj = admissionsOfficeHeaderTabsConst.find((tab) => tab.id === id);
    if (tabObj && tabObj.mass.length > 0) {
      const firstOption = tabObj.mass[0];
      setCurrentSelect(firstOption.name);
      dispatch(setTabsAdmissionsOffice(id));
      navigateToPage(id, firstOption.name);
    } else {
      dispatch(setTabsAdmissionsOffice(id));
      navigateToPage(currentTab, currentSelect);
    }
  };

  const handleChangeEvent = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value;
    setCurrentSelect(value);
    navigateToPage(currentTab, value);
  };

  const navigateToPage = (tab: string, select: string) => {
    const tabObj = admissionsOfficeHeaderTabsConst.find((t) => t.id === tab);
    const option = tabObj?.mass.find((o) => o.name === select);
    const slug = option?.slug || "admission";
    const lang = (option?.lang ?? "en") as AdmissionsLang;
    const path = lang === "en" ? `/admissions-office/${tab}/${slug}` : `/admissions-office/${lang}/${tab}/${slug}`;
    navigate(path);
  };

  return (
    <div className="header-admissions-office">
      <div className="header-bottom-tabs">
        {admissionsOfficeHeaderTabsConst.map((tab) => (
          <div className={`header-bottom-tab ${tab.id === currentTab ? "active" : ""}`} key={tab.id} onClick={() => handleEventTab(tab.id)}>
            <BtnDefault>
              <p>{tab.title}</p>
            </BtnDefault>
          </div>
        ))}
      </div>
      <VerticalLine />
      {location.pathname !== "/documents-qr-code" && (
        <>
          <div className="header-bottom-select">
            <SelectDefault onChange={handleChangeEvent} value={currentSelect}>
              {admissionsOfficeHeaderTabsConst
                .find((item) => item.id === currentTab)
                ?.mass.map((option, index) => (
                  <option key={index} value={option.name}>
                    {option.name}
                  </option>
                ))}
            </SelectDefault>
          </div>
          <VerticalLine />
        </>
      )}
      <Link to={"/documents-qr-code"}>
        <BtnDefault reverse={true}>
          <p>Documents QR Code</p>
          <DatabaseSvg />
        </BtnDefault>
      </Link>
      <div className="header-bottom-buttons">
        <BtnDefault>
          <p>New document</p>
          <Refresh />
        </BtnDefault>
        <VerticalLine />
        <Link to={"/admissions-office-database"}>
          <BtnDefault reverse={true}>
            <p>Database</p>
            <DatabaseSvg />
          </BtnDefault>
        </Link>
      </div>
    </div>
  );
};

export default HeaderAdmissionsOffice;
